// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Overlay ── */
.gcd-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1200;
}

/* ── Drawer panel ── */
.gcd-drawer {
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 80vw;

  
  background: #fff;
  z-index: 1201;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.18);
  animation: gcdSlideIn 0.22s ease;
}

@keyframes gcdSlideIn {
  from { transform: translateX(100%); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
}

/* ── Header ── */
.gcd-header {
  padding: 20px 24px 0;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.gcd-header-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 4px;
}

.gcd-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #111;
  margin: 0;
}

.gcd-subtitle {
  font-size: 0.813rem;
  color: #666;
  margin: 2px 0 12px;
}

.gcd-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  color: #444;
  display: flex;
  align-items: center;
}

.gcd-close-btn:hover { color: #000; }

/* ── Tabs ── */
.gcd-tabs {
  display: flex;
  gap: 0;
  border-bottom: none;
}

.gcd-tab {
  padding: 8px 16px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #555;
  cursor: pointer;
  border: none;
  background: none;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
}

.gcd-tab:hover { color: #111; }

.gcd-tab.active {
  color: #0860E6;
  border-bottom: 2px solid #0860E6;
  font-weight: 600;
}

/* ── Body ── */
.gcd-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
}

.gcd-body::-webkit-scrollbar { width: 4px; }
.gcd-body::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }

/* ── Section ── */
.gcd-section {
  margin-bottom: 24px;
}

.gcd-section-title {
  font-size: 0.875rem;
  font-weight: 700;
  color: #111;
  margin: 0 0 12px;
}

/* ── Radio ── */
.gcd-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.gcd-radio-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.875rem;
  color: #222;
  cursor: pointer;
  user-select: none;
}

.gcd-radio-label input[type="radio"] {
  width: 18px;
  height: 18px;
  accent-color: #0860E6;
  cursor: pointer;
  flex-shrink: 0;
}

/* ── Checkbox ── */
.gcd-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.gcd-checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.875rem;
  color: #222;
  cursor: pointer;
  user-select: none;
}

.gcd-checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #0860E6;
  cursor: pointer;
  flex-shrink: 0;
  border-radius: 4px;
}

/* ── Sub-section (indented) ── */
.gcd-sub-section {
  margin-top: 10px;
  margin-left: 28px;
  padding: 12px 16px;
  background: #f8faff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}

.gcd-sub-section-title {
  font-size: 0.813rem;
  font-weight: 700;
  color: #111;
  margin: 0 0 10px;
}

/* ── Charge input ── */
.gcd-charge-input-wrapper {
  margin-top: 8px;
  margin-left: 28px;
}

.gcd-charge-input-label {
  font-size: 0.813rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
  display: block;
}

.gcd-charge-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 0.875rem;
  color: #222;
  outline: none;
  box-sizing: border-box;
}

.gcd-charge-input:focus {
  border-color: #0860E6;
  box-shadow: 0 0 0 2px rgba(8, 96, 230, 0.12);
}

.gcd-divider {
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 20px 0;
}

/* ── Coming soon placeholder ── */
.gcd-coming-soon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #aaa;
  font-size: 0.938rem;
}

/* ── Footer ── */
.gcd-footer {
  padding: 14px 24px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  background: #fff;
}

.gcd-cancel-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  font-size: 0.875rem;
  font-weight: 500;
  color: #444;
  cursor: pointer;
}

.gcd-cancel-btn:hover { background: #f5f5f5; }

.gcd-save-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  border: none;
  border-radius: 6px;
  background: #0860E6;
  font-size: 0.875rem;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

.gcd-save-btn:hover { background: #0752c8; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/GeneralConfigDrawer/GeneralConfigDrawer.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,WAAW;;;EAGX,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA,uBAAuB,WAAW,EAAE;;AAEpC,eAAe;AACf;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,iBAAiB,WAAW,EAAE;;AAE9B;EACE,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+BAA+B,UAAU,EAAE;AAC3C,qCAAqC,mBAAmB,EAAE,kBAAkB,EAAE;;AAE9E,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,sBAAsB,mBAAmB,EAAE","sourcesContent":["/* ── Overlay ── */\n.gcd-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  z-index: 1200;\n}\n\n/* ── Drawer panel ── */\n.gcd-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: 80vw;\n\n  \n  background: #fff;\n  z-index: 1201;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.18);\n  animation: gcdSlideIn 0.22s ease;\n}\n\n@keyframes gcdSlideIn {\n  from { transform: translateX(100%); opacity: 0; }\n  to   { transform: translateX(0);    opacity: 1; }\n}\n\n/* ── Header ── */\n.gcd-header {\n  padding: 20px 24px 0;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.gcd-header-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 4px;\n}\n\n.gcd-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #111;\n  margin: 0;\n}\n\n.gcd-subtitle {\n  font-size: 0.813rem;\n  color: #666;\n  margin: 2px 0 12px;\n}\n\n.gcd-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 2px;\n  color: #444;\n  display: flex;\n  align-items: center;\n}\n\n.gcd-close-btn:hover { color: #000; }\n\n/* ── Tabs ── */\n.gcd-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: none;\n}\n\n.gcd-tab {\n  padding: 8px 16px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #555;\n  cursor: pointer;\n  border: none;\n  background: none;\n  border-bottom: 2px solid transparent;\n  white-space: nowrap;\n}\n\n.gcd-tab:hover { color: #111; }\n\n.gcd-tab.active {\n  color: #0860E6;\n  border-bottom: 2px solid #0860E6;\n  font-weight: 600;\n}\n\n/* ── Body ── */\n.gcd-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px 24px;\n}\n\n.gcd-body::-webkit-scrollbar { width: 4px; }\n.gcd-body::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }\n\n/* ── Section ── */\n.gcd-section {\n  margin-bottom: 24px;\n}\n\n.gcd-section-title {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #111;\n  margin: 0 0 12px;\n}\n\n/* ── Radio ── */\n.gcd-radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.gcd-radio-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.875rem;\n  color: #222;\n  cursor: pointer;\n  user-select: none;\n}\n\n.gcd-radio-label input[type=\"radio\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #0860E6;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n/* ── Checkbox ── */\n.gcd-checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.gcd-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.875rem;\n  color: #222;\n  cursor: pointer;\n  user-select: none;\n}\n\n.gcd-checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #0860E6;\n  cursor: pointer;\n  flex-shrink: 0;\n  border-radius: 4px;\n}\n\n/* ── Sub-section (indented) ── */\n.gcd-sub-section {\n  margin-top: 10px;\n  margin-left: 28px;\n  padding: 12px 16px;\n  background: #f8faff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n}\n\n.gcd-sub-section-title {\n  font-size: 0.813rem;\n  font-weight: 700;\n  color: #111;\n  margin: 0 0 10px;\n}\n\n/* ── Charge input ── */\n.gcd-charge-input-wrapper {\n  margin-top: 8px;\n  margin-left: 28px;\n}\n\n.gcd-charge-input-label {\n  font-size: 0.813rem;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 6px;\n  display: block;\n}\n\n.gcd-charge-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  color: #222;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.gcd-charge-input:focus {\n  border-color: #0860E6;\n  box-shadow: 0 0 0 2px rgba(8, 96, 230, 0.12);\n}\n\n.gcd-divider {\n  border: none;\n  border-top: 1px solid #f0f0f0;\n  margin: 20px 0;\n}\n\n/* ── Coming soon placeholder ── */\n.gcd-coming-soon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  color: #aaa;\n  font-size: 0.938rem;\n}\n\n/* ── Footer ── */\n.gcd-footer {\n  padding: 14px 24px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n  background: #fff;\n}\n\n.gcd-cancel-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 18px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #444;\n  cursor: pointer;\n}\n\n.gcd-cancel-btn:hover { background: #f5f5f5; }\n\n.gcd-save-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 20px;\n  border: none;\n  border-radius: 6px;\n  background: #0860E6;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n}\n\n.gcd-save-btn:hover { background: #0752c8; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
